import _noop from 'lodash/noop';

import { getEmptySelectionSet, getEmptySelectionSets } from '..';

export const getEmptyStatementSelectionProviderValue =
    (): StatementSelectionProviderValue => ({
        statementSelectionProps: {
            addStatement: _noop,
            currentSelectionSet: getEmptySelectionSet(),
            editing: null,
            hasSelectedStatement: false,
            hasStatements: false,
            isExpanded: false,
            pro: null,
            ready: false,
            saved: {
                regionFilter: 'standard',
                selectionSets: getEmptySelectionSets(),
            },
            selectedIdsString: '[]',
            selectionId: '',
            sendStatementSelectionEvent: _noop,
            setIsExpanded: _noop,
        },
    });
